import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "components/Manager/Collectables/Collected/Collected";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import { getCollectedManager } from "store/actions/managers";

const Collected = () => {
  const collectedData = useSelector((state) => state.manager.collected);
  const dispatch = useDispatch();

  const [page, setPage] = useState(collectedData ? collectedData.pag.page : 1);
  const [amount, setAmount] = useState(
    collectedData ? collectedData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    collectedData ? collectedData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    collectedData ? collectedData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    collectedData ? collectedData.pag.search_by : "item_name"
  );
  const history = useHistory();

  useEffect(() => {
    dispatch(
      getCollectedManager(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showRecycableHandler = (id) => {
    history.push("/admin/recycables/show/" + id);
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Collected Collectables</h4>
        </CardHeader>
        <CardBody>
          {collectedData && (
            <Table
              rows={collectedData.data}
              totalRows={collectedData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              showRecycable={showRecycableHandler}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Collected;
